import $ from "jquery";

$(document).on("click", ".js-prevent-link-event", function () {
  return false;
});
